module.exports = __webpack_public_path__ + "img/impacts_map.3214bc13.svg";